export class ClientDataModel {
    public clientId: number;
    public locationId: number;
    public name: string;
    public email: string;
    public phone: string;
    public disctrict: string;
    public municipality: string;
    public town: string;
    public address: string;
    public latitude: string;
    public longitude: string;
}